import { Stack, Typography } from "@mui/material";
import React from "react";
import unauthorized from "../../assets/img/unauthorized.png";

const UnauthorizedForGJ = ({ error }) => {
  return (
    <Stack direction="row" justifyContent="center" alignItems="center" height={1}>
      <Stack justifyContent="center" alignItems="center" gap={2}>
        <img src={unauthorized} alt="unauthorized" style={{ height: "150px", width: "150px" }} />
        <Typography textAlign="center">{error?.toUpperCase()}</Typography>
      </Stack>
    </Stack>
  );
};

export default UnauthorizedForGJ;
